import { configureStore } from "@reduxjs/toolkit";
import { sharedReducer } from '../shared_elements/reducers';
export const store = configureStore({
    reducer: {
        leases: sharedReducer
    }
})